
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, April 25, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import {
	View,
	StyleSheet,
} from "react-native";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";
import Breakpoints from "../../../../Breakpoints";

import NotificationIcon from "ae-base/Base/NotificationIcon";
import SquareButton from "ae-base/Base/SquareButton";
import Heading from "ae-base/Base/Heading";
import Style from "ae-style";

import { useResources } from "@aetonix/hooks";

var MAX_BUTTONS = 6;

var styles = StyleSheet.create({
	buttons: {
		flexDirection: "row",
		flexWrap: "wrap",
		justifyContent: "flex-start",
		alignSelf: "center",
	},
	notification: {
		position: "absolute",
		top: 0,
		right: 0,
	},
});

var responsiveStyles = makeIncrements(MAX_BUTTONS);

export default function FormSection(props){
	var screen = props.screen;
	var forms = props.forms;
	var title = props.title;
	var updates = props.updates;
	var forms_sections = props.forms_sections;
	var orderedformsids = props.orderedforms;

	var renderedButtons = orderedformsids.map(function(formId) {
		var form = forms[formId];
		if(!forms_sections[formId] || !form) return;
		var hasNotification = updates["groupforms_" + formId];
		return (
			<FormButton key={formId} form={form} type={"staff"} notification={hasNotification} />
		);
	});

	var renderedTitle = title  ? (
		<Heading title={title} screen={screen} />
	) : null;

	return (
		<View style={responsiveStyles.container}>
			{renderedTitle}
			<View style={styles.buttons}>
				{renderedButtons}
			</View>
		</View>
	);
}

function makeIncrements(buttons) {
	var i = buttons;
	var increment = Style.layout.squareButton + Style.layout.marginSmall;
	var definition = {};

	while(i){
		var size = increment * i;

		definition[size] = {
			container: {
				width: size,
			},
		};

		i--;
	}

	return ResponsiveStylesheet.createSized("min-width", definition);
}

function FormButton(props) {
	const {
		dispatch,
		localizeFrom,
		language,
	} = useResources();

	var form = props.form;
	var localization = form.localization;
	var icon = form.icon;

	var onPress = dispatch("ownformsubmissions:trigger:search", {
		form: form._id,
	});

	var title = localizeFrom(localization, ".") || form.name || form._id;
	var textSize = 12;
	var iconSize = Style.imageSize.tiny;

	if(Breakpoints.smallerThan("small"))
		iconSize = Style.imageSize.icon;


	var notification = props.notification ? (
		<NotificationIcon style={styles.notification} title="!" />
	) : null;

	if(title.length >= 25 && language === "ta") textSize = 9;

	return (
		<SquareButton
			key={form._id}
			title={title}
			textSize={textSize}
			icon={icon}
			iconSize={iconSize}
			onPress={onPress}>
			{notification}
		</SquareButton>
	);
}
